import React from 'react';
import { Link } from 'react-router';

import { Flex } from 'src/common/components/flex/flex';
import { Text } from 'src/common/components/text/text';

import { BlackFridayHeroBackground } from './black-friday-hero-background/black-friday-hero-background';
import './black-friday-hero.css';

export const BlackFridayHero = () => {
  return (
    <Flex className="black-friday-hero" justifyContent="space-around">
      <BlackFridayHeroBackground />
      <Flex className="black-friday-hero__offer-container" alignItems="center">
        <Text className="black-friday-hero__offer-container__ltd">
          Limited Offer 25% Off
        </Text>
        <Text className="black-friday-hero__offer-container__header">
          Get our lowest price on Pro ever!
        </Text>
        <Text className="black-friday-hero__offer-container__details">
          Get 25% off on the Streamable Pro yearly plan. The promotion is
          available until the 28th November at 11:59 PM (CET)
        </Text>

        <Link
          to="/pricing?src_internal=bf-promo-23"
          color="primary"
          className="black-friday-hero__offer-container__link"
        >
          Get offer
        </Link>
      </Flex>
    </Flex>
  );
};
